import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as galleryActions from '../../actions/gallery/galleryActions';
import * as spinnerActions from '../../actions/spinnerActions';
import * as modalActions from '../../actions/common/modalActions';
import GalleryList from './GalleryList';
import GalleryListDivs from './GalleryListDivs';
import CustomPagination from '../../components/common/CustomPagination';
import {Link} from 'react-router-dom';
import MediaQuery from 'react-responsive';
import CustomModal from '../../components/CustomModal';
import {toastr} from 'react-redux-toastr';
import BaseList from '../../components/common/list/BaseList.jsx';
import { injectIntl } from 'react-intl';
import {messages} from  '../common/Translations';
import WithResolvedPromises from "../common/WithResolvedPromises";
import PlaceholderError from "../common/PlaceholderError";
import Placeholder from "../Placeholder";
import PlaceholderTable from "../common/PlaceholderTable";

class GalleriesPage extends BaseList {
    constructor(props) {
        super(props);
        this.listId = 'galleries';
        this.deleteGalleryId = null;

        this.state = {
            page: 1,
            showModal: false,
            actions: this.getRequiredActions()
        };

        // set page from url
        if (props.match.params.page) {
            this.state.page = props.match.params.page;
        }

        this.onDelete = this.onDelete.bind(this);
    }

    getRequiredActions() {
        return [
            this.props.actions.loadGalleries(1) // (1) - page = 1
        ];
    }


    componentWillUpdate(nextProps, nextState) {
        if (this.sortParamWasChanged(nextProps)) {
            nextState.page = 1;
        }
    }

    deleteGallery() {
        if(this.deleteGalleryId !== null) {
            this.props.actions.deleteGallery(this.deleteGalleryId).then(() => {
                this.deleteGalleryId = null;
                this.props.actions.hideModal();
                toastr.success('Galleriet blev slettet');
                this.props.actions.loadGalleries(this.state.page, this.getSortParams(this.props));
            });
        } else {
            toastr.error('Kunne ikke slette galleriet');
            this.props.actions.hideModal();
        }
    }

    hideDeleteModal() {
        this.deleteGalleryId = null;
        this.props.actions.hideModal();
    }

    onDelete(id) {
        this.deleteGalleryId = id;
        this.props.actions.showModal();
    }

    onPageChange(addActions, pageNum) {
        let page = pageNum.selected + 1;
        let promise = this.props.actions.loadGalleries(page, this.getSortParams(this.props));
        addActions([promise]);
        this.setState({page: pageNum.selected + 1});
    }

    render() {
        const {galleries} = this.props;
        const galleriesData = galleries.data || [];
        return (
            <WithResolvedPromises promises={this.state.actions} preloaderComponent={PlaceholderTable}  errorComponent={PlaceholderError}>
                {
                    addActions => {
                        return (
                            <div>
                                <CustomModal
                                    modalTitle={'Slet galleri'/*this.props.intl.formatMessage(messages.galleryDeleteModalTitle)*/}
                                    modalContent={<p>Er du sikker på, at du vil slette galleriet? Hvis du sletter galleriet, sletter du samtidig alle de billeder der er i galleriet. Du skal være opmærksom på at handlingen ikke kan fortrydes!</p>/*<p>{this.props.intl.formatMessage(messages.galleryDeleteQuestion)}</p>*/}
                                    confirmText={this.props.intl.formatMessage(messages.deleteModalConfirmButton)}
                                    closeText={this.props.intl.formatMessage(messages.deleteModalCancelButton)}
                                    handleConfirm={() => {this.deleteGallery()}}
                                    handleHideModal={() => {this.hideDeleteModal()}}
                                    isOpen={this.props.showModal}
                                />
                                <div className="row">
                                    <div className="col-12">
                                        <div className="card m-b-20">
                                            <div className="card-block">
                                                <div className='row'>
                                                    <div className="col-sm-6">
                                                        <h1 className="mb-3">Gallerier{/*this.props.intl.formatMessage(messages.galleryListTitle)*/}</h1>
                                                    </div>
                                                    <div className="col-sm-6 pt-2">
                                                        <Link
                                                            to="/galleri/skab"
                                                            className="btn btn-primary waves-effect pull-right list-create-button"
                                                        >
                                                            Opret nyt billede galleri {/*this.props.intl.formatMessage(messages.galleryCreate)*/}
                                                        </Link>
                                                    </div>
                                                </div>
                                                <MediaQuery query='(max-device-width: 768px)'>
                                                    <GalleryListDivs
                                                        galleries={galleriesData}
                                                        onDelete={this.onDelete}
                                                    />
                                                </MediaQuery>
                                                <MediaQuery query='(min-device-width: 769px)'>
                                                    <GalleryList
                                                        galleries={galleriesData}
                                                        onDelete={this.onDelete}
                                                        listId={this.listId}
                                                    />
                                                </MediaQuery>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <CustomPagination
                                        total={galleries.total}
                                        page={this.state.page}
                                        onPageChange={this.onPageChange.bind(this, addActions)}
                                    />
                                </div>
                            </div>
                        );
                    }
                }
            </WithResolvedPromises>
        );
    }
}

function mapStateToProps(state, ownProps) {
    return {
        galleries: state.galleries,
        showModal: state.showModal,
        sortableList: state.sortableList,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators({
            ...galleryActions,
            ...spinnerActions,
            ...modalActions,
        }, dispatch)
    }
}

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(GalleriesPage))   ;


// WEBPACK FOOTER //
// ./web/src/components/galleries/GalleriesPage.jsx